const KeyCodes = {
  Escape: 'Escape',
  Enter: 'Enter',
  ArrowRight: 'ArrowRight',
  ArrowLeft: 'ArrowLeft',
};

export default KeyCodes;
